export default __webpack_public_path__ + "static/property-img-b5fd5a51739e0271cd36e29cf15bd537.jpg";